module.exports = __webpack_public_path__ + "images/null-template.359b8f90ec6558b6c9a131d495d084cc.png";